webpackJsonp([240199439315076],{

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _SEO = __webpack_require__(12);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _reactSvgInline = __webpack_require__(11);
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _serviciiAdministrareTehnicaLarge = __webpack_require__(465);
	
	var _serviciiAdministrareTehnicaLarge2 = _interopRequireDefault(_serviciiAdministrareTehnicaLarge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_React$Component) {
	  _inherits(Page, _React$Component);
	
	  function Page() {
	    _classCallCheck(this, Page);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Page.prototype.render = function render() {
	    var pageSEO = {
	      title: "Servicii administrare tehnica imobile",
	      description: "Oferim servicii de top in administrare tehnica imobile Bucuresti",
	      path: "/servicii/administrare-tehnica/"
	    };
	    return _react2.default.createElement(
	      "div",
	      { className: "o-page__content" },
	      _react2.default.createElement(_SEO2.default, { pageSEO: pageSEO }),
	      _react2.default.createElement(
	        "div",
	        { className: "c-section-gradient" },
	        _react2.default.createElement(
	          "div",
	          { className: "o-container u-pv-20 u-pv-30@tablet u-text-center@tablet" },
	          _react2.default.createElement(
	            "h1",
	            { className: "c-page__heading" },
	            "Servicii administrare tehnica"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "o-container u-pv-20 u-pv-30@tablet u-bg-white" },
	        _react2.default.createElement(
	          "div",
	          { className: "o-container o-container--text u-ph-0" },
	          _react2.default.createElement("img", { className: "u-mb-20", src: _serviciiAdministrareTehnicaLarge2.default, alt: "servicii administrare tehnica" }),
	          _react2.default.createElement(
	            "ol",
	            null,
	            _react2.default.createElement(
	              "li",
	              null,
	              "Verificarea propriet\u0103\u021Bii comune a asociatiei, constatarea defec\u021Biunilor ap\u0103rute si propunerea catre Comitetul Executiv de solutii tehnice pentru remedierea acestora."
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "Verificarea propriet\u0103\u021Bii individuale, numai cu acordul proprietarilor si constatarea defec\u021Biunilor ap\u0103rute. Informarea Comitetului Executiv in vederea adoptariii de solutii tehnice pentru remedierea acestora."
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "Prezentarea de oferte privind serviciile de curatenie, intretinere spatii verzi, paza, intretinere interfon, lift, pompe de apa, centrale de bloc, supraveghere video, etc. pentru aprobarea de catre Adunarea Generala a asociatiei sau catre Comitetul Executiv, dupa caz."
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "Achizitionarea materialelor pentru \xEEntre\u021Binerea \u0219i repararea defectiunilor curente aparute pe proprietatea comuna a asocia\u021Biei.\u2028"
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "Verificarea  respectarii de catre furnizorii de servicii a contractelor."
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "Supravegherea lucr\u0103rilor de repara\u021Bii \u0219i participarea alaturi de un membru al Comitetului Executiv la recep\u021Bia acestora."
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "Verificarea si repartizarea facturilor emise de catre furnizorii de de energie electric\u0103,  ap\u0103, etc, conform legii si normelor de aplicare."
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "Verificarea periodica a personalului angajat al asociatiei privind sarcina de munca specificata in fisa postului. Aducarea la cunostinta Comitetului Executiv despre eventuale nereguli aparute."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "u-color-grey-500 u-mt-30" },
	            "* Pretul serviciilor tehnice se calculeaza functie de:"
	          ),
	          _react2.default.createElement(
	            "ul",
	            { className: "u-color-grey-500" },
	            _react2.default.createElement(
	              "li",
	              null,
	              "disponibil pentru avarii 24 de ore pe zi, 7 zile pe s\u0103pt\u0103m\xE2n\u0103."
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "disponibil pentru avarii  8 ore pe zi 08.00 \u2013 16.00 ( fara sambata, duminca si sarbatorile legale)"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "u-text-center" },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/preturi/", className: "c-button u-mt-30" },
	              "Solicita o oferta personalizata"
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Page;
	}(_react2.default.Component);
	
	exports.default = Page;
	module.exports = exports["default"];

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/servicii-administrare-tehnica-large.0986f33d.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-servicii-administrare-tehnica-js-56a2502dd10aa3a7a8cf.js